export default {
  namespaced: true,
  state: () => ({
    buyDialogType: false, // 支付框活动状态
  }),
  mutations: {
    vuexChangeBuyDialogType (state, flag) { // 会员支付窗状态
      state.buyDialogType = flag
    },
  },
  actions: {
  },
  getters: {

  }
}
